export { default as Truncate } from './Truncate';
export * from './useTruncate';